import type { SxProps, Theme } from "@mui/material";

/**
 * Merges MUI sx props, handling objects, functions, and arrays.
 * Custom sx props are applied after default ones (higher specificity).
 */
export function mergeSx(
  defaultSx: SxProps<Theme>,
  customSx?: SxProps<Theme>,
): SxProps<Theme> {
  if (!customSx) return defaultSx;

  const defaultArray = Array.isArray(defaultSx) ? defaultSx : [defaultSx];
  const customArray = Array.isArray(customSx) ? customSx : [customSx];

  return [...defaultArray, ...customArray];
}
